// navigator.clipboard.writeText() only exists in a "secure context" —
// HTTPS or localhost. This app's own docker-compose.yml explicitly notes
// dashboard-web "terminates plain HTTP, no TLS in this compose" (see the
// DASHBOARD_COOKIE_SECURE comment there), so a plain-HTTP deployment is a
// real, current case, not a hypothetical — falling back to the legacy
// execCommand('copy') textarea trick when the Clipboard API isn't
// available (or rejects, e.g. permissions-policy) instead of silently
// doing nothing.
export async function copyToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fall through to the legacy path below
    }
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  // Keep it on-screen (off-viewport, not display:none) — some browsers
  // refuse to select() a hidden/display:none element for copy.
  textarea.style.position = "fixed";
  textarea.style.top = "0";
  textarea.style.left = "-9999px";
  textarea.setAttribute("readonly", "");
  document.body.appendChild(textarea);
  const selection = document.getSelection();
  const previousRange = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
  textarea.select();
  textarea.setSelectionRange(0, text.length);

  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }

  document.body.removeChild(textarea);
  if (previousRange && selection) {
    selection.removeAllRanges();
    selection.addRange(previousRange);
  }
  return ok;
}
